"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const ToolsIcon = createIcon({
  displayName: "ToolsIcon",
  viewBox: "0 0 45 45",
  path: (
    <>
      <path
        d="M39.84,45l-13.3-13.67,5.1-5.24,13.3,13.67-5.1,5.24ZM6.32,45l-5.1-5.24,16.76-17.23-4.13-4.24-1.7,1.75-3.1-3.18v5.12l-1.7,1.75L0,16.17l1.7-1.75h4.98l-3.04-3.12L12.27,2.43c.81-.83,1.68-1.44,2.61-1.81.93-.37,1.88-.56,2.85-.56s1.92.19,2.85.56c.93.37,1.8.98,2.61,1.81l-5.59,5.74,3.04,3.12-1.7,1.75,4.13,4.24,5.47-5.62c-.16-.46-.29-.94-.39-1.44-.1-.5-.15-1-.15-1.5,0-2.45.82-4.52,2.46-6.21,1.64-1.69,3.65-2.53,6.04-2.53.61,0,1.18.06,1.73.19.55.12,1.1.31,1.67.56l-6.01,6.18,4.37,4.49,6.01-6.18c.28.58.48,1.15.58,1.72.1.56.15,1.15.15,1.78,0,2.45-.82,4.52-2.46,6.21-1.64,1.69-3.65,2.53-6.04,2.53-.49,0-.97-.04-1.46-.12-.49-.08-.95-.23-1.4-.44L6.32,45Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default ToolsIcon;
